import { useParams } from "react-router-dom";

import ExpenseForm from "../ExpenseForm";

const ExpenseEditPage = () => {

    const { id } = useParams();

    return (

        <ExpenseForm

            mode="edit"

            expenseId={id}

        />

    );

};

export default ExpenseEditPage;